import { render, staticRenderFns } from "./list.vue?vue&type=template&id=18b68ebe&scoped=true"
import script from "./list.vue?vue&type=script&lang=ts"
export * from "./list.vue?vue&type=script&lang=ts"
import style0 from "./list.vue?vue&type=style&index=0&id=18b68ebe&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18b68ebe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sahil-meshram/Documents/Eiosys/BFP-Admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('18b68ebe')) {
      api.createRecord('18b68ebe', component.options)
    } else {
      api.reload('18b68ebe', component.options)
    }
    module.hot.accept("./list.vue?vue&type=template&id=18b68ebe&scoped=true", function () {
      api.rerender('18b68ebe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/master/industries/list.vue"
export default component.exports